import { observable, makeObservable } from 'mobx';

import { t } from '@gem/modules/i18n';

import { PayloadType } from 'APP/model/message/messageModel.types';

import { ImagePayload } from '../ImagePayload/ImagePayload';
import { Payload } from '../Payload';
import { VideoPayload } from '../VideoPayload/VideoPayload';

const PayloadClass = {
  [PayloadType.Image]: ImagePayload,
  [PayloadType.Video]: VideoPayload,
};

export class AdvertisementPayload extends Payload {
  @observable payloads;
  comment;
  buttonCaption;
  buttonUrl;

  constructor(data) {
    super({ ...data, payloadType: PayloadType.Advertisement });
    makeObservable(this);

    this.payloads = data.payloads
      .sort((a, b) => a.order - b.order)
      .map(({ id, order, payloadType, payload }) => ({
        id,
        order,
        payloadType,
        payload: new PayloadClass[payload.payloadType]({
          ...payload,
          message: {
            forward: null,
            repliedMessage: null,
            quote: null,
            hasError: false,
            setError() {
              this.hasError = true;
            },
          },
        }),
      }));
    this.comment = data.comment;
    this.buttonCaption = data.buttonCaption;
    this.buttonUrl = data.buttonUrl;
  }

  toJSON() {
    return {
      ...super.toJSON(),
      comment: this.comment || null,
      buttonCaption: this.buttonCaption || null,
      buttonUrl: this.buttonUrl || null,

      payloads: this.payloads.map((payload, idx) => ({
        id: payload.id,
        payloadType: payload.payloadType,
        order: idx,
        payload: payload.payload.toJSON(),
      })),
    };
  }

  get canBeDelete() {
    return false;
  }

  get text() {
    return t('common_advertisement');
  }
}
